<template>
  <div class="callme_total_wrap">
    <div class="callme_top_wrap_adds">
      <el-row class="card_wrap">
        <el-col  class="brain_item" :lg="12" :sm="24">
          <div class="item_title">
            美好前璟 点亮热爱<br/>
            期待您的加入
          </div>
          <!-- 轮播指示点 -->
          <div class="dots-container">
            <span class="dot dot-active"></span>
            <span class="dot dot-middle"></span>
            <span class="dot dot-inactive"></span>
          </div>
          <div class="item_pic"/>
        </el-col>
        <el-col class="brain_item brain_item_ti" :lg="12" :sm="24">
          <div style="width: 70%">
            <div class="item_title_sm">
              公司地址
            </div>
            <!-- 轮播指示点 -->
            <div class="dots-container">
              <span class="dot dot-active"></span>
              <span class="dot dot-middle"></span>
              <span class="dot dot-inactive"></span>
            </div>
            <div class="en-text">
              Company<br/>
              Address
            </div>
            <div class="address-detail">辽宁省葫芦岛市</div>
            <div class="address-detail_2">东戴河新区A区长城大道西段1号</div>

            <div class="item_title_sm">
              招商热线
            </div>
            <!-- 轮播指示点 -->
            <div class="dots-container">
              <span class="dot dot-active"></span>
              <span class="dot dot-middle"></span>
              <span class="dot dot-inactive"></span>
            </div>
            <div class="en-text">
              Contact<br/>
              Information
            </div>
            <div class="address-detail">400-0011-147</div>
          </div>
          <div class="action-item" style="margin-top: 40px;">
              <img class="action-item-logo" src="../../../assets/img/home/callme/ArrarLOGO.png" alt="品牌LOGO">
              <div class="action-item">
                <img src="../../../assets/img/home/callme/collect.png" alt="收藏">
                <a href="#" class="action-link  collect-link">收藏</a>
              </div>
              <div class="action-item">
                <img src="../../../assets/img/home/callme/share.png" alt="分享">
                <a href="#" class="action-link share-link">分享</a>
              </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <el-row style="height: 100%" class="items_wrap">
          <el-col  class="item_options_logo" :lg="4" :sm="24">
              <img  @click="handleToRouter('/home')" class="img_logo" src="../../../assets/img/home/callme/down_logo.png">
          </el-col>
          <el-col  class="item_options nav-left" :lg="4" :sm="24">
            <span @click="handleToRouter('/table')">璟点台球桌</span>
            <span @click="handleToRouter('')">璟点俱乐部</span>
            <span @click="handleToRouter('/join')">加盟申请</span>
          </el-col>
          <el-col  class="item_options nav-left" :lg="4" :sm="24">
            <span @click="handleToRouter('/contest')">璟点赛事</span>
            <span @click="handleToRouter('')">台顶会商学院</span>
            <span @click="handleToHttp('https://www.jdgk.top/')">客满台计费系统</span>
          </el-col>
          <el-col  class="item_options nav-right" :lg="4" :sm="24">
            <span @click="handleToHttp('https://www.predatorcues.com/')">Predator美洲豹台球杆</span>
            <span @click="handleToRouter('/websitePoison')">Poison毒药台球杆</span>
            <span @click="handleToHttp('https://www.universal-billiard.com/index.php')">Universal环球台球杆</span>
          </el-col>
          <el-col  class="item_options nav-right" :lg="4" :sm="24">
            <span @click="handleToRouter('/websiteGf')">鬼斧台球杆</span>
            <span @click="handleToHttp('https://www.dufferincues.com/index.php/Index/index/index.html')">Dufferin达芬尼</span>
            <span @click="handleToRouter('/portal_check')">真伪查询</span>
<!--            <span @click="handleToRouter('')">全国销售/渠道网络</span>-->
          </el-col>
          <el-col  class="item_options qrcode-col" :lg="4" :sm="24">
            <img class="img_code" src="../../../assets/img/home/callme/secher.png">
            <img class="img_weixin" src="../../../assets/img/home/callme/weixin.png">
<!--            <span style="padding-top: 10px">真伪查询</span>-->
          </el-col>
        </el-row>
      </div>
      <div class="navigate_wrap">
        <span>版权所有：璟点（辽宁）体育用品有限公司</span>
        <span>辽ICP备2023002664号</span>
        <span>网站地图</span>
        <span>诚聘英才</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    handleToRouter(url) {
      if(url){
        if (url !== this.$route.path) {
          if (url === '/websiteGf'){
            this.$router.push({
              path: "/website",
              query: { type: "gf" }
            });
          }else if(url === '/websitePoison'){
            this.$router.push({
              path: "/website",
              query: { type: "poison" }
            });
          }else{
            this.$router.replace(url)
          }
        }
      }
    },
    handleToHttp(url) {
      if(url){
        // 在新的标签页中打开链接
        window.open(url, '_blank');
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  margin-top: -150px;

  .callme_top_wrap_adds {
    width: 100%;
    //padding-top: 80px;
    .card_wrap {
      width: 100%;
      flex-wrap: wrap;
      margin: 0px auto;
      justify-content: space-around;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      .brain_item_ti {
        display: flex;
        padding-top: 60px;
        @media screen and (max-width: 768px) {
          padding-top: 30px;
        }
      }
      .brain_item {
        transition: background-color 1s;
        padding-left: 150px;
        @media screen and (max-width: 768px) {
          font-size: 0.8rem;
          line-height: 15PX;
          border-radius: 10PX;
          //display: flex;
          flex-wrap: wrap;
          justify-content: center;
          &:nth-child(-n+2){
            margin-top: 0;
          }
        }
        margin-top: 20px;
        position: relative;
        .item_bg {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          opacity: 0;
          transition: all 0.5s;
          border-radius: 20px;
          z-index: 1;
        }
        &:hover .item_bg{
          opacity: 1;
        }
        .item_title {
          transition: all 0.5s;
          font-size: 40px;
          //font-weight: bold;
          color: #203040;
          text-align: left;
          padding: 20px 0 20px 0;
          z-index: 2;
          position: inherit;
          @media screen and (max-width: 768px) {
            font-size: 10px;
          }
        }
        .item_title_sm {
          transition: all 0.5s;
          font-size: 20px;
          font-weight: bold;
          color: #203040;
          text-align: left;
          padding: 20px 0 20px 0;
          z-index: 2;
          position: inherit;
          @media screen and (max-width: 768px) {
            font-size: 12px;
            padding: 8px 0 8px 0;
          }
        }
        .en-text {
          font-family: Arial;    /* 西文字体 */
          font-size: 10px;       /* 小字号 */
          color: #9FA0A0;        /* 灰色文字 */
          line-height: 10px;     /* 精确行高 */
          @media screen and (max-width: 768px) {
            line-height: 20px;
            font-size: 12px;
          }
        }
        .address-detail {
          font-family: HarmonyOS_Sans_SC; /* 中文字体 */
          font-size: 20px;       /* 大字号 */
          color: #3E3A39;        /* 文字颜色 */
          line-height: 37px;     /* 行高设置 */
          @media screen and (max-width: 768px) {
            line-height: 20px;
            font-size: 12px;
          }
        }
        .address-detail_2 {
          font-family: HarmonyOS_Sans_SC; /* 中文字体 */
          font-size: 20px;       /* 大字号 */
          color: #3E3A39;        /* 文字颜色 */
          line-height: 37px;     /* 行高设置 */
          padding-bottom: 40px;
          @media screen and (max-width: 768px) {
            line-height: 20px;
            font-size: 12px;
          }
        }

        /**************** 新增交互样式 ****************/
        .action-item {
          width: 30%;
          position: relative;
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding-bottom: 30px;
        }
        .action-item-logo {
          width: 30%;
          padding-bottom: 30px;
        }

        .action-link {
          cursor: pointer;
          font-family: 'HarmonyOS_Sans_SC', sans-serif;
          font-size: 14px;
          color: #3E3A39;
          text-decoration: none;
          transition: all 0.3s ease;
          text-align: center;
        }

        .action-link:hover {
          color: #007BFF;
          transform: translateY(2px);
        }

        .item_title_en {
          transition: all 0.5s;
          font-size: 15px;
          font-weight: bold;
          color: #203040;
          text-align: left;
          padding: 20px 0 40px 0;
          z-index: 2;
          position: inherit;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
            text-align: center;
          }
        }
        .item_pic{
          width: 80%;
          height: 250px;
          background: url('../../../assets/img/home/callme/cooperate.png') 0 0 no-repeat;
          background-size: 100% 100%;
          @media screen and (max-width: 768px) {
            height: 100px;
          }
          @media screen and (min-width: 768px) and (max-width: 1199px) {
            height: 250px;
          }
        }
        .item_desc {
          transition: all 0.5s;
          color: #203040;
          text-align: left;
          line-height: 1.5rem;
          z-index: 2;
          position: inherit;
          font-size: 23px;
          min-height: 110px;
          letter-spacing: 3px;
          font-weight: 500;
          @media screen and (max-width: 768px) {
            min-height: 110PX;
            text-indent: 2em;
            font-size: 12px;
          }
          p {
            line-height: 1.5;
            padding-top: 40px;
          }
        }
        .item_navigate {
          width: 100PX;
          height: 35PX;
          padding: 0 10px;
          background: #033885;
          color: #fff;
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          margin-left: 90%;
          cursor: pointer;
          z-index: 2;
          position: inherit;
          @media screen and (max-width: 768px) {
            margin-bottom: 10PX;
            font-size: 14px;
          }
        }
      }
    }
  }

  .callme_bottom_wrap {
    width: 100%;
    background: #2d2d2d;
    color: #fff;
    .bottom_container {
      width: 100%;
      margin: 0 auto;
      display: flex;
      border-bottom: solid #363636 2px;
      .items_wrap {
        width: 100%;
        // PC端保持原有6列布局
        display: flex;
        flex-wrap: nowrap;
        text-align: center;

        .item_options_logo {
          //display: flex;
          flex-direction: column;
          width: 16.6%;
          align-items: center;
          justify-content: center;
          margin-top: 52px;
          .img_logo{
            width: 160px;
            cursor: pointer;
          }
        }
        .item_options {
          display: flex;
          flex-direction: column;
          width: 16.6%;
          //justify-content: center;
          margin-top: 52px;
          .img_logo{
            width: 160px;
            height: 50px;
          }
          .img_code{
            width: 100px;
            height: 100px;
            margin-left: 50px;
          }
          .img_weixin{
            margin-top: 10px;
            margin-left: 55px;
            width: 92px;
            height: 15px;
            transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            position: relative;
          }
          span {
            color: #FFFFFF;
            padding-bottom: 10px;
            cursor: pointer;
            &:hover {
              color: #f3bf78;
            }
          }
          .el_menu_demo {
            border: none;
            background: none;
            margin-top: 10px;
            width: 300PX;
            .el_menu_item {
              &:hover {
                font-weight: bold;
              }
            }
          }
          .massage_show {
            color: hsla(0, 0%, 100%, 0.5);
            font-size: 15px;
            width: 300PX;
            height: 80px;
            p {
              margin-top: 30px;
            }
          }
          img {
            width: 100%;
          }
        }

        // 移动端：强制两列布局 + 解决文字重叠
        @media screen and (max-width: 768px) {
          display: flex;
          flex-wrap: wrap; // 自动换行，形成两列
          gap: 15px; // 列之间的间距，避免挤在一起
          padding: 20px 50px;

          // 左列（50%宽度）：包含Logo + 基础导航 + 赛事/商学院
          .item_options_logo {
            width: 100% !important; // Logo独占一行，和二维码列一致
            margin-top: 0 !important;
            padding-bottom: 15px !important; // 边框上方留白
            display: flex;
            flex-direction: column;
            align-items: center !important; // 居中显示（和二维码列一致）
            justify-content: center;
            border-bottom: 1px solid #363636 !important; // 添加底部边框
            margin-bottom: 15px !important; // 边框下方间距
          }

          // Logo列样式优化
          .item_options_logo .img_logo {
            width: 120px;
            height: 40px;
          }

          // 基础导航/赛事列（左列）
          .nav-left {
            width: calc(50% - 7.5px) !important; // 50%宽度 - 一半gap
            margin-top: 0 !important;
            display: flex;
            flex-direction: column;
            align-items: flex-start; // 文字左对齐
            justify-content: flex-start;
          }

          // 右列（50%宽度）：包含所有球杆内容
          .nav-right {
            width: calc(50% - 7.5px) !important; // 50%宽度 - 一半gap
            margin-top: 0 !important;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
          }

          // 文字样式：统一间距+行高，解决重叠
          .nav-left span, .nav-right span {
            padding-bottom: 12px !important;
            font-size: 12px !important;
            line-height: 1.5 !important; // 增加行高，避免上下重叠
            white-space: nowrap; // 防止文字换行挤压
            overflow: hidden;
            text-overflow: ellipsis; // 过长文字显示省略号
          }

          // 二维码列：放在最下方，独占一行（100%宽度）
          .qrcode-col {
            width: 100% !important;
            margin-top: 10px !important;
            min-height: 150px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-top: 1px solid #363636; // 加分割线区分内容
            padding-top: 15px !important; // 边框下方留白
            .img_code {
              width: 120px;
              height: 120px;
            }
            .img_weixin {
              margin-left: 0 !important;
              margin-top: 8px !important;
              width: 40px;
              height: 12px;
            }
            .code-text {
              padding: 8px 0 0 0 !important;
              font-size: 13px !important;
            }
          }
        }
      }
    }
    .navigate_wrap {
      background-color: #0f0f0f;
      width: 100%;
      min-height: 60px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      a {
        color: hsla(0, 0%, 100%, 0.5);
        font-size: 16px;
        margin-right: 33px;
        text-decoration: none;
      }
      span {
        color: #4e5557;
        padding-left: 100px;
        font-size: 14px;
        font-weight: bold;
      }
      p {
        font-size: 16px;
        color: #4e5557;
      }

      @media screen and (max-width: 768px) {
        min-height: 80px;
        justify-content: center;
        span {
          padding: 0 10px;
          font-size: 12px;
        }
      }
    }
  }
}

.dots-container {
  display: flex;
  gap: 10px;
  padding-left: 0.4em;
  padding-bottom: 20px;
  @media screen and (max-width: 768px) {
    padding-left: 0;
    padding-bottom: 8px;
  }
}

.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #007BFF;
  @media screen and (max-width: 768px) {
    width: 5px;
    height: 5px;
  }
}

.dot-active { opacity: 1; }
.dot-middle { background: linear-gradient(90deg, #007BFF 30%, rgba(159, 160, 160, 0.5) 70%); }
.dot-inactive { background: rgba(159, 160, 160, 0.2); }
</style>